import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { isValidHeadingType, isValidHeadingSize } from './Heading.Context/index.es.js';
import { HeadingProvider } from './Heading.Context/provider.es.js';
import { HeadingEyebrow } from './Heading.Eyebrow/Heading.Eyebrow.es.js';
import { HeadingHeader } from './Heading.Header/Heading.Header.es.js';
import { HeadingIcon } from './Heading.Icon/Heading.Icon.es.js';
import { HeadingIntro } from './Heading.Intro/Heading.Intro.es.js';

const Heading = ({ alignment = 'left', className, children, iconName, layout = 'horizontal', variant = 'title/md', status, loop, ...props })=>{
    const { size, type } = useMemo(()=>{
        const [type, size] = variant.split('/');
        if (!isValidHeadingType(type) || !isValidHeadingSize(size)) {
            throw new Error('Invalid variant.');
        }
        return {
            size,
            type
        };
    }, [
        variant
    ]);
    return jsx(HeadingProvider, {
        alignment: alignment,
        layout: layout,
        size: size,
        type: type,
        children: jsxs("div", {
            className: classNames('cb-heading', alignment, className, layout, size, type),
            ...props,
            children: [
                iconName && jsx(HeadingIcon, {
                    iconName: iconName,
                    loop: loop,
                    status: status
                }),
                jsx("div", {
                    className: "text",
                    children: children
                })
            ]
        })
    });
};
Heading.displayName = 'Heading';
Heading.Eyebrow = HeadingEyebrow;
Heading.Header = HeadingHeader;
Heading.Intro = HeadingIntro;

export { Heading, Heading as default };
//# sourceMappingURL=Heading.es.js.map
